export default {
    install(Vue) {
      Vue.prototype.$dateformat = (payload) => {

        if(payload === '0001-01-01' || payload === '') {
          return '-';
        }
        
        payload = new Date(payload)

        let month = String(payload.getMonth() + 1);
        let day = String(payload.getDate());
        const year = String(payload.getFullYear());
      
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
      
        return `${day}/${month}/${year}`;
      };
    }
  };
  